import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider,KeyboardDateTimePicker } from "@material-ui/pickers";
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import './EventEditComplete.css'


const wStyles = theme => ({
    textLink:{     
        height:40,
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:"auto",
        '&:hover':{
            color:"black",
        },
    },
    eventEditCompleteFieldTimeInput:{
        border: "1px solid",
        padding: "10px",
        borderRadius: "5px",
        backgroundColor: "#ffffff"
    },
    iconCheckFalse:{
        width:"5em",
        height:"5em",
        color:"#ff0000"
    },
    iconCheckTrue:{
        width:"5em",
        height:"5em",
        color:"#0080ff"
    }
})

class EventEditComplete extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showCheckArea:false,
            showTestImageArea:false,
            testImageUrl:null
        }
    }

    componentDidMount(){
        //this.initialEventDate()
    }

    componentDidUpdate(){
   
    }

    componentWillUnmount(){

    }

    initialEventDate=()=>{
        if(!this.props.eventDurationDate)
        {
            let eventDate = {
                eventStartTime:"2018-01-01 00:00",
                eventEndTime:"2018-01-01 00:00",
            }

            this.props.getEventDurationDate(eventDate)
        }
    }

    setEventStartTime=(msg)=>{
        if(this.state.eventStartTime !== msg)
        {
            this.setState({
                eventStartTime:msg
            })
        }
    }

    setEventEndTime=(msg)=>{
        if(this.state.eventEndTime !== msg)
        {
            this.setState({
                eventEndTime:msg
            })
        }
    }

    setEventDurationDate=(value, type)=>{
        console.log(value.getTime())
       
        if(value.getTime())
        {
            let output
            let tempSDate
            let tempEDate
            if(this.props.eventDurationDate)
            {
                tempSDate = this.props.eventDurationDate.eventStartTime
                tempEDate = this.props.eventDurationDate.eventEndTime
            }
            else
            {
                tempSDate = "2018-01-01 00:00"
                tempEDate = "2018-01-01 00:00"
            }

            if(type === "start")
            {     
           
                output = {
                    //eventStartTime:value.toISOString().slice(0, 19).replace('T', ' '),
                    eventStartTime:value.getFullYear()+"-"+Number(value.getMonth()+1)+"-"+value.getDate()+" "+value.getHours()+":"+value.getMinutes(),
                    eventEndTime:tempEDate
                }
            }
            else if(type === "end")
            {
                output = {
                    eventStartTime:tempSDate,
                    //eventEndTime:value.toISOString().slice(0, 19).replace('T', ' ')
                    eventEndTime:value.getFullYear()+"-"+Number(value.getMonth()+1)+"-"+value.getDate()+" "+value.getHours()+":"+value.getMinutes()
                }
            }

            //console.log("month : ",value.getMonth())
            //console.log("date : ", value.getDate())
            //console.log("hour : ", value.getHours())
            //console.log("minute : ", value.getMinutes())
            //console.log(output)

            this.props.getEventDurationDate(output)
        }
        else
        {
            //console.log("Z2")
        }
    }

    eventUpload=()=>{
        this.setState({
            showCheckArea:true
        })
        if(this.props.fieldCheck.eventAbstractContentCheck && this.props.fieldCheck.compositionContainersCheck && this.props.fieldCheck.eventDateCheck)
        {
            this.props.postEvent()
            //this.props.history.push("/EventManagement/Default")
        }
        else
        {
            console.log("Check failed !")
        }
    }


    render(){
        const {classes} = this.props;

        let scrollContainer={
            position:"relative",
            top:200,
            width:"100%",
            height:"100%",
            backgroundColor:"#9a9999",
        }

        let eventEditCompleteFieldTimeInput={
            border: "1px solid",
            padding: "10px",
            borderRadius: "5px",
            backgroundColor: "#ffffff"
        }

        let eventEditCompleteFieldSysID = {
            border: "1px solid",
            padding: "10px",
            borderRadius: "5px",
            backgroundColor: "#ffffff",
            fontSize:"25px",
            lineHeight:"80px"
        }

        let checkIconStyle = {
            border: "1px solid",
            borderRadius: "5px",
            lineHeight:"0px",
            textAlign:"center",
            fontFamily:""
        }

        return (

            <div style={scrollContainer} >
                <div style={{display:"flex"}}>
                    {this.props.eventSysID?
                    <div className={"eventEditCompleteFieldGroup"}>
                        <div className={"eventEditCompleteFieldTitle"}>專題ID</div>
                        <div style={eventEditCompleteFieldSysID}>{this.props.eventSysID}</div>
                    </div>
                    :
                    <div className={"eventEditCompleteFieldGroup"}>
                        <div className={"eventEditCompleteFieldTitle"}>專題暫時ID</div>
                        <div style={eventEditCompleteFieldSysID}>{this.props.tempEventSysID}</div>
                    </div>
                    }
                    <div className={"eventEditCompleteFieldGroup"}>
                        <div className={"eventEditCompleteFieldTitle"}>專題刊登起始日期及時間</div>
                        <MuiPickersUtilsProvider  utils={DateFnsUtils}>
                            <KeyboardDateTimePicker style={eventEditCompleteFieldTimeInput} variant="inline" ampm={false} label="選擇或輸入日期及時間" value={this.props.eventDurationDate? this.props.eventDurationDate.eventStartTime:"2018-01-01 00:00"} onChange={(value)=>this.setEventDurationDate(value,"start")} onError={console.log} format="yyyy/MM/dd HH:mm"/>
                        </MuiPickersUtilsProvider>
                    </div>
                    <div className={"eventEditCompleteFieldGroup"}>
                        <div className={"eventEditCompleteFieldTitle"}>專題刊登結束日期及時間</div>
                        <MuiPickersUtilsProvider  utils={DateFnsUtils}>
                            <KeyboardDateTimePicker style={eventEditCompleteFieldTimeInput} variant="inline" ampm={false} label="選擇或輸入日期及時間" value={this.props.eventDurationDate? this.props.eventDurationDate.eventEndTime:"2018-01-31 08:00"} onChange={(value)=>this.setEventDurationDate(value,"end")} onError={console.log} format="yyyy/MM/dd HH:mm"/>
                        </MuiPickersUtilsProvider>
                    </div>
                </div>
                <div style={{display:"flex", margin:"10px"}}>
                    {this.props.eventSession ? 
                        <Button className={classes.textLink} startIcon={<DesktopWindowsIcon />} onClick={this.eventUpload}>
                            專題編輯完成
                        </Button>
                        :null
                    }  
                </div>
                {this.state.showTestImageArea?<div><img src={this.state.testImageUrl} alt={"loadimage"}/></div>:null}
                {this.state.showCheckArea?
                <div style={{display:"flex", margin:"10px"}}>
                    <div className={"eventEditCompleteFieldGroup"}>
                        <div className={"eventEditCompleteFieldTitle"}>專題標體檢查</div>
                        {this.props.fieldCheck.eventAbstractContentCheck?<div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CheckIcon className={classes.iconCheckTrue}/></div></div>:<div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CloseIcon className={classes.iconCheckFalse}/></div><div><p>請檢查</p><p>1. 標題背景圖像已上傳1張以上</p><p>2. 主標題已填寫(非預設值)</p><p>3. 副標題已填寫(非預設值)</p><p>4. 標題簡述已填寫(非預設值)</p></div></div>}
                    </div>
                    <div className={"eventEditCompleteFieldGroup"}>
                        <div className={"eventEditCompleteFieldTitle"}>專題內容檢查</div>
                        {this.props.fieldCheck.compositionContainersCheck?<div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CheckIcon className={classes.iconCheckTrue}/></div></div>:<div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CloseIcon className={classes.iconCheckFalse}/></div><div><p>請檢查</p><p>1. 有設定1個以上內容區塊</p><p>2. 影像區塊都有上傳影像</p><p>3. 文字區塊有填寫文字並且有儲存(非預設值)</p></div></div>}
                    </div>
                    <div className={"eventEditCompleteFieldGroup"}>
                        <div className={"eventEditCompleteFieldTitle"}>專題刊登時間檢查</div>
                       {this.props.fieldCheck.eventDateCheck? <div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CheckIcon className={classes.iconCheckTrue}/></div></div>:<div style={eventEditCompleteFieldSysID}><div style={checkIconStyle}><CloseIcon className={classes.iconCheckFalse}/></div><div><p>請檢查</p><p>1. 起始時間不等同結束時間</p><p>2. 結束時間需晚於起始時間</p></div></div>}
                    </div>
                </div>
                :null}
            </div>     
        )  
    }
}

export default withStyles(wStyles)(EventEditComplete)